module.exports = __webpack_public_path__ + "img/char3.3a483a98.png";